<template lang="pug">
  .columns.is-vcentered
    .column.is-3-desktop
    .login.column.is-6
      section.section
        .has-text-centered
          img.login-logo(:src="ecoinventLogo")
          .content
            h3 {{ $t('Data Converter Login') }}
          form(@submit.prevent="submitLogin")
            b-field(:label="$t('E-Mail')")
              b-input(type="email" v-model="email" icon="user" @input="clearError" rounded)
            b-field(:label="$t('Password')")
              b-input(type="password" v-model="password" icon="key" @input="clearError" rounded)
            transition(name="fade")
              .error(v-if="errorMessage" key="errorMessage")
                p.is-danger {{ errorMessage }}
            .has-text-centered
              input.button.is-vcentered.is-primary.is-outlined(type="submit" :value="$t('Login')")
            .has-text-centered
              ul
                li
                  router-link(to='/login/register') {{ $t('Sign up for a new account') }}
                li
                  router-link(to='/login/forgot-password') {{ $t('Forgot your password?') }}
    .column.is-3-desktop
</template>

<script>
import { login } from '../utils/api'

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: null,
      ecoinventLogo: require('../assets/ecoinvent Brand mark.png')
    }
  },
  methods: {
    submitLogin() {
      login(this.email, this.password)
        .then(() => {
          this.$store.commit('login')
          this.$router.push('/')
        })
        .catch((error) => {
          let errorMessage = ''
          let errorData = error.response.data
          if (!errorData) {
            this.errorMessage = this.$t('An error occurred while logging you in. Please contact support at support@ecoinvent.com .')
          } else {
            if (errorData.email && errorData.password) {
              errorMessage = this.$t('Please enter your email address and your password.')
            } else if (errorData.email) {
              errorMessage = this.$t('Please enter your email address.')
            } else if (errorData.password) {
              errorMessage = this.$t('Please enter your password.')
            }
            if (errorData.non_field_errors) {
              errorMessage = error.response.data.non_field_errors.join(';')
            }
            this.errorMessage = errorMessage
          }
        })
    },
    clearError() {
      this.errorMessage = null
    }
  }
}
</script>

<style scoped lang="scss">
  .input {
    border-radius: 50px;
  }

  .button {
    margin-top: 20px;
    margin-bottom: 20px;
    min-width: 150px;
  }

  .login-logo {
    margin: 0 2rem 5rem;
    max-height: 100px;
  }

  .is-danger {
    color: #e01a1a;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue